export const loadEstimatorScript = (fileVersion, onLoadFunction, isMobile) => {
  const location = window ? window.location.host.toLowerCase() : '';
  const isLlcEnvironment = location.includes('hd-qa71.homedepotdev')
    || location.includes('hd-qa74.homedepotdev')
    || location.includes('localhost');
  const fileUrl = isLlcEnvironment
    ? `https://assets-qa.homedepot-static.com/paymentestimator/${fileVersion}/payment-estimator.js`
    : `https://assets.homedepot-static.com/paymentestimator/${fileVersion}/payment-estimator.js`;
  const head = document.querySelector('head');
  const script = document.createElement('script');
  script.setAttribute('src', fileUrl);
  script.onload = () => {
    onLoadFunction(isMobile);
  };
  head.appendChild(script);
};
